import type { ConsoleScreenMap } from '../types'
import { lazyScreen } from '../lazyScreen'
const SupportScreen = lazyScreen(() => import('./support/SupportScreen'), (m) => m.SupportScreen)
const RevenueScreen = lazyScreen(() => import('./revenue/RevenueScreen'), (m) => m.RevenueScreen)
const PipelineScreen = lazyScreen(() => import('./sales/PipelineScreen'), (m) => m.PipelineScreen)
const QuotesScreen = lazyScreen(() => import('./sales/QuotesScreen'), (m) => m.QuotesScreen)
const RenewalsScreen = lazyScreen(() => import('./sales/RenewalsScreen'), (m) => m.RenewalsScreen)
const GroupsScreen = lazyScreen(() => import('./sales/GroupsScreen'), (m) => m.GroupsScreen)
const OverviewScreen = lazyScreen(() => import('./insights/OverviewScreen'), (m) => m.OverviewScreen)
const SchoolsScreen = lazyScreen(() => import('./insights/SchoolsScreen'), (m) => m.SchoolsScreen)
const AnalyticsScreen = lazyScreen(() => import('./insights/AnalyticsScreen'), (m) => m.AnalyticsScreen)
const PeopleScreen = lazyScreen(() => import('./insights/PeopleScreen'), (m) => m.PeopleScreen)
const TeamScreen = lazyScreen(() => import('./platform/TeamScreen'), (m) => m.TeamScreen)
const AuditScreen = lazyScreen(() => import('./platform/AuditScreen'), (m) => m.AuditScreen)
const SystemScreen = lazyScreen(() => import('./platform/SystemScreen'), (m) => m.SystemScreen)
const GamesScreen = lazyScreen(() => import('./platform/GamesScreen'), (m) => m.GamesScreen)
const DevicesScreen = lazyScreen(() => import('./platform/DevicesScreen'), (m) => m.DevicesScreen)
const WebsiteScreen = lazyScreen(() => import('./website/WebsiteScreen'), (m) => m.WebsiteScreen)

/**
 * The operator tier's redesigned screens, by route. A route listed here is served
 * by the console registry ahead of AppRouter's older switch; a route not
 * listed keeps its existing screen. Owned by the operator workstream.
 */
export const OPERATOR_SCREENS: ConsoleScreenMap = {
  /* ops-money: Support (B4 / B4b) */
  'platform-support': { component: SupportScreen },
  /* ops-money: Revenue (K16 / K16b / K16c / R3 + subscriptions, coupons) */
  'platform-subscriptions': { component: RevenueScreen },
  'platform-coupons': { component: RevenueScreen },
  /* ops-sales: Pipeline/requests/enquiry/set-up (B1 K2 K3 K4), Quotes (B2), Renewals (B3), Groups (B7) */
  'platform-requests': { component: PipelineScreen },
  'platform-quotes': { component: QuotesScreen },
  'platform-renewals': { component: RenewalsScreen },
  'platform-groups': { component: GroupsScreen },
  /* ops-insights: Overview (K15 / K15b) */
  platform: { component: OverviewScreen },
  /* ops-insights: Schools + school profile (K7 / K8, K8b–K8g) */
  'platform-schools': { component: SchoolsScreen },
  /* ops-insights: Analytics (A7 / K14 / A8 as tabs) */
  'platform-engagement': { component: AnalyticsScreen },
  /* ops-insights: People (K17) */
  'platform-people': { component: PeopleScreen },
  /* ops-platform: Team (K11) — also serves the old Operators route */
  'platform-team': { component: TeamScreen },
  'platform-operators': { component: TeamScreen },
  /* ops-platform: Activity log (K12) */
  'platform-audit': { component: AuditScreen },
  /* ops-platform: Settings (K13) — also serves the old Broadcast route */
  'platform-system': { component: SystemScreen },
  'platform-broadcast': { component: SystemScreen },
  /* ops-platform: Games (K10) */
  'platform-games': { component: GamesScreen },
  /* ops-platform: Devices (B6) */
  'platform-devices': { component: DevicesScreen },
  /* ops-platform: Website (P3-21) — a Foundation stub until PKG-PLATFORM lands it */
  'platform-website': { component: WebsiteScreen },
}
